import React from 'react';

import './login-card.scss';
import { Link } from 'react-router-dom';

import Logo from 'components/Logo';

type ILogin = {
  title: string,
  create?: boolean,
  back?: boolean,
  children: React.ReactNode,
};

const Login = ({
  back = true,
  create = true,
  title,
  children,
}: ILogin) => (
  <div className='login'>
    <Logo className='login-logo' />
    <hr />
    <h3>{title}</h3>
    {children}
    {create && (
      <>
        <hr />
        <div className='create'>
      Don’t have an account yet? <Link to='/sign-in'>Create Account</Link>
        </div>
      </>
    )}
    {back && (
      <>
        <hr />
        <div className='create'>
          <Link to='/login'>Back to login</Link>
        </div>
      </>
    )}
  </div>
);

export default Login;